import { ROUTE_PATH } from 'routes';
import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import CmsBlocks from 'components/CmsBlocks/v2';

const Welcome = () => {
  const { authenticated } = useSelector((state) => state.session);
  const navigate = useNavigate();

  useEffect(() => {
    if (authenticated) {
      navigate(ROUTE_PATH.HOME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <AppShell>
        <CmsBlocks />
      </AppShell>
    </Layout>
  );
};

export default Welcome;
